<template>
  <div class="container order-list">
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>

    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div class="sForm">
        <el-form :inline="true" id="searchForm" label-width="70px">
          <el-form-item label="商品名称" prop="orderNo">
            <el-input v-model.trim="searchForm.goodsName" size="small" placeholder="请输入商品名称" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="下单用户" prop="userInfo">
            <el-input v-model.trim="searchForm.userInfo" size="small" placeholder="请输入下单用户" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="收货人" prop="postUserInfo">
            <el-input v-model.trim="searchForm.postUserInfo" size="small" placeholder="收货人信息" clearable></el-input>
          </el-form-item>
          <el-form-item label="来源平台" prop="miniAppId">
            <el-select style="width: 232px" v-model="searchForm.miniAppId" placeholder="请选择来源平台" filterable clearable
              size="small">
              <el-option v-for="item in apps" :key="item.appid" :label="item.name" :value="item.appid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单编号" prop="orderNo">
            <el-input v-model.trim="searchForm.orderNo" size="small" placeholder="请输入订单编号" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="售后编号" prop="afterNo">
            <el-input v-model.trim="searchForm.afterNo" size="small" placeholder="请输入售后编号" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="售后类型" prop="orderType">
            <el-select v-model="searchForm.afterType" placeholder="请选择售后类型" size="small" filterable clearable>
              <el-option v-for="item in dictionaries.platform_order_after_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="售后状态" prop="orderType">
            <el-select v-model="searchForm.afterStatus" placeholder="请选择售后状态" size="small" filterable clearable>
              <el-option v-for="item in dictionaries.platform_order_after_status" :key="item.dictId"
                :label="item.dictName" :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间" prop="createdTime">
            <el-date-picker v-model="searchForm.createdTime" type="daterange" size="small" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="提交时间" prop="createdTime">
            <el-date-picker v-model="searchForm.createdTime" type="daterange" size="small" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="申请时间" prop="createdTime">
            <el-date-picker v-model="searchForm.createdTime" type="daterange" size="small" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="订单类型" prop="orderType">
            <el-select v-model="searchForm.orderType" placeholder="请选择订单类型" size="small" filterable clearable>
              <el-option v-for="item in dictionaries.platform_order_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label=" " label-width="0px" style="margin-left:-6px">
            <el-button type="primary" size="small" @click="fetchData('search')"
              @keyup.enter="fetchData('search')">查询</el-button>
            <el-button type="primary" plain size="small" @click="fetchData('reset')">重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="btn-list tabclass">
        <h3>数据列表</h3>
        <!-- <div>
          <el-button type="primary" :loading="exportLoading" icon="el-icon-upload2" @click="lotsExport">批量导出</el-button>
        </div> -->
        <div>
          <el-button type="primary" :loading="exportLoading" @click="settingAddress">退货地址设置</el-button>
        </div>
      </div>
      <orders-list-table :dataList="page.list" :heightStr="columns.height" :config="columnCommon.config"
        @lookDialog="lookDialog" @optionDialog="optionDialog" typeStr="afterOrder"
        @tableSelectionChange="handleSelectionChange"></orders-list-table>
      <!-- 分页start -->
      <div class="page">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="page.pageNo" :page-sizes="[3, 5, 10, 20, 50]" :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="page.totalNum">
        </el-pagination>
      </div>
      <!-- 分页end -->
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" append-to-body width="40%">
      <div style="margin-bottom: 10px">
        <el-form ref="dialogForm" :model="dialogForm" label-width="80px" :rules="rules">
          <el-form-item label="物流公司" prop="logisticsCompany">
            <el-select style="width: 100%" v-model="dialogForm.logisticsCompany" placeholder="请选择物流公司" filterable>
              <el-option v-for="(item, index) in dictionaries.courier_company" :key="index" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="logisticsNumber">
            <el-input v-model="dialogForm.logisticsNumber" placeholder="请输入物流单号"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div style="display: flex; justify-content: end; margin-top: 24px">
        <div class="info-q" @click="dialogVisible = false">取消</div>
        <div class="info-s" @click="submit">确定</div>
      </div>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="dialogLook" append-to-body width="40%">
      <StepLogistics :stepProgress="logisticsMessage"></StepLogistics>

      <div style="display: flex; justify-content: end; margin-top: 24px">
        <div class="info-q" @click="dialogLook = false">取消</div>
        <div class="info-s" @click="dialogLook = false">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import ordersListTable from '../components/ordersListTable'
import StepLogistics from '../components/StepLogistics.vue'
export default {
  components: {
    ordersListTable,
    breadcrumbTop,
    breadcrumbSearch,
    StepLogistics
  },
  data() {
    return {
      radio1: '0',
      searchList: {
        list: [
          { title: '售后订单', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      dataList: {
        list: [
          { title: '订单管理', path: '', type: '0' },
          { title: '售后订单', path: '', type: '1' }
        ]
      },
      exportLoading: false,
      loadingState: false,
      loadingStateTwo: false,
      loadingStateThree: false,
      loadingStateFour: false,
      loading: false,
      parArray: [],
      userType: '',
      columns: {
        type: 'all',
        height: '5000px',
        sortObj: {},
        config: []
      },
      // 公共  column
      columnCommon: {
        type: 'common',
        sortObj: { prop: 'marketPrice', order: 'descending' }, // 排序
        config: [
          { type: 'selection', width: 50 },
          { prop: 'no', label: '售后编号', width: 150, slot: 'no' },
          // { prop: 'remarks', label: '售后编号', width: 100, slot: 'no' },
          { prop: 'payTypeLabel', label: '商品信息', width: 300, slot: 'info' },
          { prop: 'user', label: '下单用户', width: 120, slot: 'user' },
          { prop: 'post', label: '收货人', width: 120, slot: 'post' },
          { prop: 'postDistrictAddress', label: '收货地址', width: 140, slot: 'address' },
          { prop: 'refundMoney', label: '金额', width: 80, slot: 'refundMoney' },
          { prop: 'miniAppName', label: '来源平台', width: 100, slot: 'miniAppName' },
          // { prop: 'createdTime', label: '申请时间', width: 150, },
          { prop: 'afterTypeLabel', label: '售后类型', width: 100 },
          { prop: 'afterReasonLabel', label: '售后原因', width: 100, },
          { prop: 'statusLabel', label: '售后状态', width: 100, slot: 'status' },
          {
            prop: 'approveRemark', label: '备注', width: 150, slot: 'approveRemark'
          },
          {
            prop: 'remarks', label: '操作', width: 120, align: 'center'
          }
        ]
      },
      multipleSelection: '', // 多选
      cancelOrderId: '', // 取消订单id
      setCloseOrder: '', // 取消订单参数
      statusCount: {
        waitingSubmitCount: 0, // 提交订单前 待提交
        closedCount: 0, // 已关闭数量
        finishedCount: 0, // 已完成数量
        prePostCount: 0, // 待发货数量
        preReceivedCount: 0, // 待签收数量
        processCount: 0, // 审核中数量
        totalCount: 0 // 全部数量
      },
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        goodsName: null,
        userInfo: null,
        postUserInfo: null,
        orderNo: null,
        afterNo: null,
        afterType: null,
        afterStatus: null,
        approveTimeStart: null,
        approveTimeEnd: null,
        orderType: null
      },
      currentTab: '', // 当前列表状态
      // 分配状态
      currentTabStatus: {
        all: '', // 全部
        beforePay: 1, // 待支付
        choicing: 2, // 备货中
        signFor: 3, // 待签收
        accomplish: 4, // 已完成
        afterSale: 6 // 已关闭
      },
      columnTitle: this.column,
      breadcrumbConfig: {
        list: [
          {
            title: '订单管理',
            type: '#ff0000',
            path: ''
          },
          {
            title: '运营订单',
            type: '1',
            path: ''
          }

        ]
      },
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      rQuery: {},
      afterSale: '',
      dictionaries: {
        platform_order_type: [],
        platform_order_after_type: [],
        platform_order_after_status: []
      },
      apps: [],
      dialogVisible: false,
      title: '发货',
      dialogForm: {
        logisticsCompany: '',
        logisticsNumber: '',
      },
      rules: {

        logisticsCompany: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        logisticsNumber: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
        ],
      },
      dialogLook: false,
      logisticsMessage: {},
    }
  },
  watch: {
    $route: {
      handler(val, oldVal) {

      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.getDictionaries('platform_order_type')
    this.getDictionaries('platform_order_after_type')
    this.getDictionaries('platform_order_after_status')
    this.getDictionaries('courier_company')
    this.getDictionaries('order_status_logistics')

    this.fetchData()
    this.getAppList()
    // this.$forceUpdate()
    // this.initSearchList()// 初始化，搜索需要的列表数据
  },
  mounted() {
    // this.$nextTick(_ => {
    //   const rQuery = this.rQuery
    //   if (rQuery.state) {
    //     this.onChangeCurrentTab(Number(rQuery.state))
    //     this.currentTab = rQuery.state || ''
    //   } else {
    //     this.onChangeCurrentTab() // fetchData 在这里执行
    //   }
    //   console.log('this.currentTab = ', this.currentTab)
    // })
  },
  methods: {
    lookDialog(val) {
      this.dialogLook = true
      console.log(val)
      this.getlogistics(val.val.id, val.type)
    },
    // 物流信息
    getlogistics(id, type) {
      const params = {
        id: id,
        logisticsType: type
      }
      this.axios.get('/orders/after/getLogisticsDetail', { params: params }).then(res => {
        if (res.code == 0) {
          if (this.dictionaries.order_status_logistics.length !== 0 && res.data.status) {
            res.data.statusCn = this.dictionaries.order_status_logistics.find(e => { return e.dictId === res.data.status }).dictName
          }
          if (this.dictionaries.courier_company.length !== 0 && res.data.logisticsCompany) {
            res.data.logisticsCompanyCN = this.dictionaries.courier_company.find(e => { return e.dictId === res.data.logisticsCompany }).dictName
          }
          // console.log(logisticsCompany)
          this.logisticsMessage = res.data
          // this.logisticsMessage.logisticsCompany = logisticsCompany
        }
      })
    },
    submit() {
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          if (this.title == '填写退货单号') {
            let data = {
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.axios.post('/orders/after/logistics/addLogistics', data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.fetchData()
              }

            })
          } else if (this.title == '寄出换货') {
            let data = {
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.axios.post('/orders/after/delivery', data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.fetchData()
              }

            })
          } else {
            let type = 0
            if (this.title == '修改退货单号') {
              type = 1
            } else {
              type = 2
            }
            let data = {
              logisticsType: type,
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.axios.post('/orders/after/logistics/updateLogisticsNo', data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.fetchData()
              }

            })
          }
        } else {
          return false;
        }
      });

    },
    //操作
    optionDialog(val) {
      console.log(val)
      if (val.type == 'delivery') {
        this.title = '寄出换货'
        this.dialogVisible = true
        this.dialogForm.logisticsNumber = ''
        this.dialogForm.logisticsCompany = ''
        this.orderId = val.val.id
      } else if (val.type == 'hedit') {
        this.title = '修改换货单号'
        this.dialogVisible = true
        this.orderId = val.val.id
        this.dialogForm.logisticsNumber = val.val.logisticsNumber
        this.dialogForm.logisticsCompany = val.val.logisticsCompany
      } else if (val.type == 'fedit') {
        this.title = '填写退货单号'
        this.dialogVisible = true
        this.orderId = val.val.id
        this.dialogForm.logisticsNumber = val.val.logisticsNumber
        this.dialogForm.logisticsCompany = val.val.logisticsCompany
      } else {
        this.title = '修改退货单号'
        this.dialogVisible = true
        this.orderId = val.val.id
        this.dialogForm.logisticsNumber = val.val.logisticsNumber
        this.dialogForm.logisticsCompany = val.val.logisticsCompany
      }

    },
    getAppList() {
      this.axios.get('/miniApp/getMiniAppIdName').then(res => {
        if (res.code == 0) {
          this.apps = res.data
        }
      })
    },
    settingAddress() {
      this.$router.push({
        name: 'settingAddress',
        query: {

        }
      })
    },
    //批量导出
    lotsExport() {
      let ids = []
      if (this.multipleSelection) {
        this.multipleSelection.forEach(item => {
          ids.push(item.id)
        })
      }

      this.exportLoading = true
      this.searchForm.ids = ids
      this.axios.post('/orders/after/export', this.searchForm).then(res => {
        if (res.code == 0) {
          this.exportLoading = false
          this.$message.success('导出成功')
          this.downloadlink(res.data)
        }
      })
    },
    downloadlink(url) {
      const protocol = location.protocol
      let resultUrl = url
      if (protocol === 'https:') {
        resultUrl = url.replace(`http:`, `${protocol}`)
      }
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = resultUrl
      document.body.appendChild(iframe)
    },
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/sys/dictByGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
          }
        })
    },
    onChangeCurrentTab(status) {
      this.page.pageNo = 1
      this.page.pageSize = 10
      this.page.currentPage = 1
      let strTemp = 'all'
      let configTemp = [...this.columnCommon.config]
      this.columns.type = strTemp
      this.columns.config = Array.from(new Set(configTemp))
      this.fetchData('search')
    },
    fetchData(type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {

        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      this.axios.post('/orders/after/pageList', this.searchForm).then((res) => {
        if (res.code === 0) {
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false
        } else {
          console.log('goodsPageList - 失败', type)
        }
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
      console.log(currentChange, 'currentChange')
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageNo = 1
      this.page.currentPage = 1
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },

    // 订单数量统计查询
    getStatusCount(params) {
      // const params = {}
      this.$api.getStatusCount(params).then((res) => {
        this.statusCount = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 初始化，搜索需要的列表数据
    initSearchList() {
      const params = { pageNo: 1, pageSize: 1001 }
      // this.getPlatformDataList(params) // 平台
      // this.getShopDataList(params) // 店铺
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>
<style scoped lang="scss">
.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.sForm {
  .el-input {
    width: 232px !important;
  }

  .el-select {
    width: 232px !important;
  }

  .el-range-editor {
    width: 232px !important;
  }
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

.page {
  text-align: right;
  margin: 10px auto;
}

/deep/ .hide-content {
  display: none !important;
}

/deep/ .show-content {
  display: inline-block;
}

/deep/ .el-link {
  margin: 0 5px;
}

.search-form .el-form-item {
  width: 100%;
  // max-width: 295px;
  width: 250px;
  margin-right: 10px;

  .el-date-picker {
    width: 250px;
  }
}

/deep/ .el-table th>.cell,
/deep/ .el-table td {
  text-align: unset;
}

.tabclass {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.yellowBtn,
.blueBtn,
.serviceDerive,
.promotionDerive {
  height: 36px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.yellowBtn {
  //width: 160px;
  //height: 36px;
  background: #edb840;
  //border-radius: 4px;
}

.blueBtn {
  //width: 120px;
  //height: 36px;
  background: #4168e7;
  //border-radius: 4px;
}

.serviceDerive {
  //width: 160px !important;
  background: #67c23a !important;
}

.promotionDerive {
  //width: 160px !important;
  background: #e6a23c !important;
}

.serviceDeriveTwo {
  //width: 160px !important;
  background: #0f82c5 !important;
}

.promotionDeriveTwo {
  //width: 160px !important;
  background: #b705fd !important;
}

.tabBtn {
  //width: 100px;
  height: 36px;
  padding: 0 12px;
  border-radius: 4px;
  margin-bottom: 10px;
}

/deep/ .el-tabs {
  margin-top: 20px;

  .el-tabs__header {
    .el-tabs__nav-wrap {
      .el-tabs__nav-scroll {
        padding: 0;

        .el-tabs__nav {
          .el-tabs__active-bar {
            display: none;
          }

          .el-tabs__item {
            margin-right: 20px;
            width: 120px;
            height: 36px;
            padding: 0;
            text-align: center;
            line-height: 36px;
            font-size: 16px;
            color: #999999;
            border-radius: 4px;
            background: #ececec;
          }

          .el-tabs__item.is-active {
            color: #333333;
            background: #e3edff;
          }
        }
      }
    }
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }
}

.shopTitle {
  margin-bottom: 20px;
}

// /deep/ .el-button {
//   border: none;
// }

.search-form {
  .el-form-item {
    max-width: 312px;

    /deep/ .el-form-item__label {
      width: 100px;
    }

    /deep/ .el-form-item__content {
      width: calc(100% - 100px);

      // .el-date-editor {
      //   //width: calc(100% - 82px);
      // }
    }
  }
}

.orderNotes {
  margin-top: 24px;
  padding-bottom: 25px;
  border-bottom: 1px solid #d9d9d9;

  .headerOrder {
    .orderRemak {
      margin-bottom: 12px;
      font-size: 18px;
    }
  }
}

/deep/ .el-textarea__inner {
  height: 132px;
}

.statistics {
  margin-top: 30px;
  display: flex;
  justify-content: right;
  align-items: center;

  .fourteen {
    font-size: 14px;
    padding-right: 20px;
  }

  .blue {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 0px;
    color: #4168e7;
  }
}

.present {
  display: flex;
  justify-content: right;
  height: 36px;
  margin-top: 30px;
  padding-bottom: 28px;
}

.tabsBtn {
  display: flex;
}

.dialogBtnright {
  display: flex;
  justify-content: space-between;
}

.dialogBtnright_right {
  display: flex;
  justify-content: right !important;
}

.setPay_payment_btn_quxiao {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  color: rgba(153, 153, 153, 1);
  border-radius: 4px;
  line-height: 0;
}

.setPay_payment_btn_queren {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  border: 0;
}

.setPay_payment {
  display: block;
  margin-bottom: 15px;
}

.dialog-btn {
  text-align: right;
}

/deep/ .el-table__row td .cell p {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
}

/*
/deep/.el-table__row td .cell span, /deep/.el-table__row td .cell div p{
  display: block;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
*/
/deep/ .el-scrollbar {
  height: 10px;
}

/deep/ .el-scrollbar__bar.is-horizontal {
  height: 9px;
}

::v-deep .el-form-item__label {
  padding: 0px 10px 0 0;
}
</style>
<style lang="scss">
.el-dropdown-menu .el-dropdown-menu__item:hover {
  background-color: white;
  color: #2D46EE;
}
</style>
